var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EDE9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37134 22.6691C9.59153 24.7273 11.2468 26.3826 13.3039 26.6119C14.8318 26.7821 16.4006 26.9284 18.0001 26.9284C19.5996 26.9284 21.1684 26.7821 22.6962 26.6119C24.7534 26.3826 26.4087 24.7273 26.6288 22.6691C26.7914 21.1499 26.9287 19.5901 26.9287 17.9999C26.9287 16.4096 26.7914 14.8498 26.6288 13.3305C26.4087 11.2725 24.7534 9.61716 22.6962 9.38787C21.1684 9.21756 19.5996 9.07129 18.0001 9.07129C16.4006 9.07129 14.8318 9.21756 13.3039 9.38787C11.2468 9.61716 9.59153 11.2725 9.37134 13.3305C9.20879 14.8498 9.07153 16.4096 9.07153 17.9999C9.07153 19.5901 9.2088 21.1499 9.37134 22.6691Z",
    fill: "#F5F3FF",
    stroke: "#6D28D9",
    strokeWidth: 2.14286
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1429 17.2857C16.3263 17.2857 17.2857 16.3263 17.2857 15.1429C17.2857 13.9594 16.3263 13 15.1429 13C13.9594 13 13 13.9594 13 15.1429C13 16.3263 13.9594 17.2857 15.1429 17.2857Z",
    fill: "#C4B5FD",
    stroke: "#6D28D9",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3038 26.6119C11.2468 26.3826 9.59147 24.7274 9.37128 22.6692C9.35763 22.5416 9.34416 22.4138 9.33093 22.2856H26.6692C26.6559 22.4138 26.6424 22.5416 26.6289 22.6692C26.4086 24.7274 24.7533 26.3826 22.6963 26.6119C21.1683 26.7822 19.5995 26.9285 18 26.9285C16.4006 26.9285 14.8318 26.7822 13.3038 26.6119Z",
    fill: "#C4B5FD",
    stroke: "#6D28D9",
    strokeWidth: 2.14286
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2857 18C24.0679 18 25.5975 19.0335 26.834 20.4412C26.7893 21.0619 26.732 21.677 26.6692 22.2857H15.2902C17.2552 19.9508 19.6683 18 22.2857 18Z",
    fill: "#C4B5FD",
    stroke: "#6D28D9",
    strokeWidth: 2.14286,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.28cadae1c2ca8da3b01cad7ec032e0b0.svg";
export { ForwardRef as ReactComponent };